import { Form } from 'antd';
import React from 'react';
import ModalTitle from '../modalTitle/ModalTitle';
import { Text, CloseIcon } from '../../../styles/common.styles';
import { blueDark01 } from '../../../styles/colors';
import ModalFooter from '../modalFooter/ModalFooter';
import { DeleteProjectModal, DeleteSpin } from './DeleteModal.styles';

interface Props {
    isOpen: boolean;
    closeModal: (data: { key: 'delete' }) => void;
    reload: (modal: string) => void;
    text: React.ReactNode;
    title: string;
    icon?: string;
    pending?: boolean;
    questionMark?: boolean;
    itemList?: string[];
}
const DeleteModal: React.FC<Props> = ({
    isOpen,
    closeModal,
    reload,
    text,
    title,
    icon,
    pending,
    questionMark = true,
    itemList = [],
}) => {
    const handleCancel = () => {
        closeModal({ key: 'delete' });
    };

    const onDelete = () => {
        reload('delete');
    };

    return (
        <DeleteProjectModal
            open={isOpen}
            onCancel={handleCancel}
            centered
            footer={null}
            className="delete-modal-container"
            closeIcon={<CloseIcon />}
        >
            <DeleteSpin spinning={pending ?? false}>
                <Form onFinish={onDelete}>
                    <ModalTitle title={`Delete ${title}`} icon={icon} />
                    <Text weight={400} size={14} height={18} color={blueDark01}>
                        Are you sure you want to delete {text}{questionMark ? '?' : ''}
                    </Text>
                    {itemList.length > 0 && (
                        <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
                            {itemList.map((item, index) => (
                                <li key={item}>
                                    <Text size={14} weight={400} color={blueDark01}>
                                        {item}
                                    </Text>
                                </li>
                            ))}
                        </ul>
                    )}
                    <ModalFooter cancel={handleCancel} submit={() => { }} action="Delete" />
                </Form>
            </DeleteSpin>
        </DeleteProjectModal>
    );
};

export default DeleteModal;
